
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateFreelancerLegalBypassRequest,
  FreelancerLegalBypassResource,
  ValidationError,
} from '../models';
import {
    CreateFreelancerLegalBypassRequestFromJSON,
    CreateFreelancerLegalBypassRequestToJSON,
    FreelancerLegalBypassResourceFromJSON,
    FreelancerLegalBypassResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateFreelancerLegalBypassOperationRequest {
    companyId: string;
    createFreelancerLegalBypassRequest: CreateFreelancerLegalBypassRequest;
}

export interface GetFreelancerLegalBypassesRequest {
    companyId: string;
}

/**
 * 
 */
export class FreelancerLegalBypassApi extends runtime.BaseAPI {

    /**
     * Create a new legal check bypass for a freelancer company
          */
    async createFreelancerLegalBypassRaw(requestParameters: CreateFreelancerLegalBypassOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerLegalBypassResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling createFreelancerLegalBypass().'
            );
        }

        if (requestParameters['createFreelancerLegalBypassRequest'] == null) {
            throw new runtime.RequiredError(
                'createFreelancerLegalBypassRequest',
                'Required parameter "createFreelancerLegalBypassRequest" was null or undefined when calling createFreelancerLegalBypass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerLegalBypassResource>({
            path: `/compliance/api/companies/{companyId}/legal-bypass`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFreelancerLegalBypassRequestToJSON(requestParameters['createFreelancerLegalBypassRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerLegalBypassResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a new legal check bypass for a freelancer company
          */
    async createFreelancerLegalBypass(requestParameters: CreateFreelancerLegalBypassOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerLegalBypassResource> {
        const response = await this.createFreelancerLegalBypassRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get all legal check bypasses for a freelancer company
          */
    async getFreelancerLegalBypassesRaw(requestParameters: GetFreelancerLegalBypassesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FreelancerLegalBypassResource>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getFreelancerLegalBypasses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FreelancerLegalBypassResource>>({
            path: `/compliance/api/companies/{companyId}/legal-bypass`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FreelancerLegalBypassResourceFromJSON);
        return response;
    }

    /**
     * Get all legal check bypasses for a freelancer company
          */
    async getFreelancerLegalBypasses(requestParameters: GetFreelancerLegalBypassesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FreelancerLegalBypassResource>> {
        const response = await this.getFreelancerLegalBypassesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
